import { render, staticRenderFns } from "./DashboardAppModal.vue?vue&type=template&id=6c0de1a8&scoped=true&"
import script from "./DashboardAppModal.vue?vue&type=script&lang=js&"
export * from "./DashboardAppModal.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAppModal.vue?vue&type=style&index=0&id=6c0de1a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0de1a8",
  null
  
)

export default component.exports